import Hero from '../components/home/Hero'
import StatsSection from '../components/home/StatsSection'
import FavouritesSection from '../components/home/FavouritesSection'
import JourneySection from '../components/home/JourneySection'
import WhyChooseUs from '../components/home/WhyChooseUs'
import CtaBand from '../components/common/CtaBand'
import SEO from '../components/common/SEO'
import { seoData, localBusinessSchema } from '../data/seoData'

function Home() {
  return (
    <div>
      <SEO
        title={seoData.home.title}
        description={seoData.home.description}
        keywords={seoData.home.keywords}
        url={seoData.home.url}
        image={seoData.home.image}
        structuredData={localBusinessSchema}
      />
      <Hero />
      <StatsSection />
      <FavouritesSection />
      <JourneySection />
      <WhyChooseUs />
      <CtaBand body="Build your cake in three short steps. We confirm on WhatsApp." />
    </div>
  )
}

export default Home
